"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
var _operationsConfig = require("@/api/community/operationsConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TaskSettings',
  data: function data() {
    return {
      form: {
        rewards: Array.from({
          length: 7
        }).map(function () {
          return {
            type: 'score',
            value: '',
            desc: ''
          };
        }),
        banner: {
          linkType: 'system',
          target: 'couponSquare'
        },
        backgroundImages: [],
        // 签到背景图列表
        bannerImages: [],
        // 签到banner图列表
        rules: {
          signinReward: 0,
          followReward: 0,
          addMiniReward: 0,
          likeReward: 0,
          likeMax: 0,
          commentReward: 0,
          commentMax: 0,
          shareReward: 0,
          shareMax: 0
        },
        rulesText: '1、签到奖励周期为7天，根据用户实际连续天数，发放对应积分奖励，每日递增1积分\n2、冲递断签后重新累计，每个会员账户每天仅限签到1次',
        deduction: {
          deletePost: 0,
          cancelReview: 0
        }
      },
      signinDays: [{
        label: '积分奖励',
        days: [1, 2, 3, 4, 5, 6, 7]
      }],
      dialogVisible: false,
      // 图片预览对话框显示状态
      dialogImageUrl: '',
      // 预览图片URL
      backgroundImagePath: '',
      // 签到背景图相对路径
      bannerImagePath: '',
      // 签到banner图相对路径
      rawTask: null // 保存原始task数据，提交时合并保留前端未编辑的字段
    };
  },
  created: function created() {
    this.loadConfig();
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      (0, _operationsConfig.getConfigById)(1003).then(function (res) {
        if (res.data && res.data.value) {
          try {
            var config = JSON.parse(res.data.value);
            var task = config.task;
            if (!task) return;
            _this.rawTask = task; // 保留原始数据，提交时合并

            // --- 签到积分 (sign: {"1":"1","2":"2",...} → signinDays.days) ---
            if (task.sign) {
              for (var i = 1; i <= 7; i++) {
                _this.$set(_this.signinDays[0].days, i - 1, parseInt(task.sign[String(i)]) || 0);
              }
            }

            // --- 签到奖励v2 (signv2 → form.rewards) ---
            if (task.signv2 && task.signv2.length) {
              _this.form.rewards = task.signv2.map(function (item) {
                return {
                  type: item.reward_type === '1' ? 'score' : 'coupon',
                  value: item.reward || '',
                  desc: item.tips || ''
                };
              });
            }

            // --- 签到规则 ---
            if (task.sign_v2_rules) {
              _this.form.rulesText = task.sign_v2_rules;
            }

            // --- 签到日常奖励 ---
            if (task.signv2_praise_options !== undefined) {
              _this.form.rules.signinReward = parseInt(task.signv2_praise_options) || 0;
            }

            // --- 点赞/评论/分享 任务规则 ---
            if (task.praise) {
              _this.form.rules.likeReward = parseInt(task.praise.options) || 0;
              _this.form.rules.likeMax = parseInt(task.praise.max) || 0;
            }
            if (task.comment) {
              _this.form.rules.commentReward = parseInt(task.comment.options) || 0;
              _this.form.rules.commentMax = parseInt(task.comment.max) || 0;
            }
            if (task.share) {
              _this.form.rules.shareReward = parseInt(task.share.options) || 0;
              _this.form.rules.shareMax = parseInt(task.share.max) || 0;
            }

            // --- 关注公众号 / 添加小程序 ---
            if (task.subscriber !== undefined) {
              _this.form.rules.followReward = parseInt(task.subscriber) || 0;
            }
            if (task.myminiapp !== undefined) {
              _this.form.rules.addMiniReward = parseInt(task.myminiapp) || 0;
            }

            // --- 签到背景图 ---
            if (task.sign_bg_url) {
              _this.backgroundImagePath = task.sign_bg_url;
              _this.form.backgroundImages = [{
                url: (0, _operationsConfig.getImageUrl)(task.sign_bg_url),
                name: 'background.jpg'
              }];
            }

            // --- 签到banner图 ---
            if (task.sign_banner_url) {
              _this.bannerImagePath = task.sign_banner_url;
              _this.form.bannerImages = [{
                url: (0, _operationsConfig.getImageUrl)(task.sign_banner_url),
                name: 'banner.jpg'
              }];
            }

            // --- banner跳转 ---
            if (task.jump_type !== undefined) {
              _this.form.banner.linkType = task.jump_type === 3 ? 'system' : 'custom';
            }
            if (task.linkurl) {
              _this.form.banner.target = task.linkurl.includes('puzzle') ? 'couponSquare' : 'taskCenter';
            }

            // --- 积分扣减 ---
            if (task.del_tj_comment !== undefined) {
              _this.form.deduction.deletePost = parseInt(task.del_tj_comment) || 0;
            }
            if (task.del_sh_comment !== undefined) {
              _this.form.deduction.cancelReview = parseInt(task.del_sh_comment) || 0;
            }
          } catch (e) {
            console.error('解析任务配置失败', e);
          }
        }
      });
    },
    onReset: function onReset() {
      this.$refs.opsForm.resetFields();
      // 重置图片列表
      this.form.backgroundImages = [];
      this.form.bannerImages = [];
      this.backgroundImagePath = '';
      this.bannerImagePath = '';
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      // 签到积分 sign: {"1":"1","2":"2",...}
      var sign = {};
      for (var i = 0; i < 7; i++) {
        sign[String(i + 1)] = String(this.signinDays[0].days[i] || 0);
      }

      // 签到奖励v2 signv2: [{day:"2",reward_type:"1",reward:"1",tips:"..."}]
      var signv2 = this.form.rewards.map(function (reward, index) {
        return {
          day: String(index + 2),
          reward_type: reward.type === 'score' ? '1' : '2',
          reward: String(reward.value || ''),
          tips: reward.desc || "\u5956\u52B1\u79EF\u5206:".concat(reward.value)
        };
      });

      // 合并：保留前端未编辑的原始字段（wecom, show_img, reply等）
      var raw = this.rawTask || {};
      var taskConfig = {
        sign: sign,
        comment: {
          max: this.form.rules.commentMax,
          options: this.form.rules.commentReward
        },
        praise: {
          max: this.form.rules.likeMax,
          options: this.form.rules.likeReward
        },
        reply: raw.reply || {
          max: 3,
          options: 3
        },
        share: {
          max: this.form.rules.shareMax,
          options: this.form.rules.shareReward
        },
        signv2: signv2,
        sign_v2_rules: this.form.rulesText,
        signv2_praise_options: this.form.rules.signinReward,
        subscriber: this.form.rules.followReward,
        myminiapp: this.form.rules.addMiniReward,
        wecom: raw.wecom || 0,
        sign_bg_url: this.backgroundImagePath || raw.sign_bg_url || '',
        sign_banner_url: this.bannerImagePath || raw.sign_banner_url || '',
        show_img: raw.show_img || '',
        jump_type: this.form.banner.linkType === 'system' ? 3 : 1,
        linkurl: this.form.banner.target === 'couponSquare' ? '/packages/pages/puzzle/market/index' : raw.linkurl || '',
        del_tj_comment: this.form.deduction.deletePost,
        del_sh_comment: this.form.deduction.cancelReview
      };
      (0, _operationsConfig.updateConfig)(1003, JSON.stringify({
        task: taskConfig
      })).then(function () {
        _this2.$message.success('已保存任务设置');
        _this2.loadConfig();
      });
    },
    onExceed: function onExceed() {
      this.$message.warning('仅可上传一张图片');
    } // 图片预览
    ,
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    } // 删除图片
    ,
    handleRemove: function handleRemove(file, fileList) {
      // 判断是背景图还是banner图
      if (fileList === this.form.backgroundImages) {
        this.form.backgroundImages = fileList;
        this.backgroundImagePath = '';
      } else if (fileList === this.form.bannerImages) {
        this.form.bannerImages = fileList;
        this.bannerImagePath = '';
      }
    } // 背景图变化处理 - 立即上传
    ,
    handleBackgroundChange: function handleBackgroundChange(file, fileList) {
      var _this3 = this;
      if (file && file.raw) {
        (0, _operationsConfig.uploadImage)(file.raw, '/').then(function (res) {
          _this3.backgroundImagePath = res.data;
          file.url = (0, _operationsConfig.getImageUrl)(res.data);
          _this3.form.backgroundImages = [file];
        });
      }
    } // banner图变化处理 - 立即上传
    ,
    handleBannerChange: function handleBannerChange(file, fileList) {
      var _this4 = this;
      if (file && file.raw) {
        (0, _operationsConfig.uploadImage)(file.raw, '/').then(function (res) {
          _this4.bannerImagePath = res.data;
          file.url = (0, _operationsConfig.getImageUrl)(res.data);
          _this4.form.bannerImages = [file];
        });
      }
    } // 上传前验证
    ,
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    } // 添加签到奖励
    ,
    addReward: function addReward() {
      this.form.rewards.push({
        type: 'score',
        value: '',
        desc: ''
      });
    } // 删除签到奖励
    ,
    removeReward: function removeReward(index) {
      var _this5 = this;
      if (this.form.rewards.length <= 1) {
        this.$message.warning('至少需要保留一项签到奖励');
        return;
      }
      this.$confirm('确定要删除此项签到奖励吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.form.rewards.splice(index, 1);
        _this5.$message.success('已删除签到奖励项');
      }).catch(function () {
        // 用户取消删除
      });
    }
  }
};